import * as tslib_1 from "tslib";
import { FirebaseSyncService } from '../services/firebase-sync.service';
import { JobDataService } from './job-data.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { PostcodeManagerService } from '../services/postcode-manager.service';
import { PricingService } from './pricing.service';
import { environment } from '../../environments/environment';
import { Clients, TradeTypes } from './globals.service';
import * as i0 from "@angular/core";
import * as i1 from "./firebase-sync.service";
import * as i2 from "./job-data.service";
import * as i3 from "@angular/fire/firestore";
import * as i4 from "./postcode-manager.service";
import * as i5 from "./pricing.service";
import * as i6 from "./globals.service";
export class MetaDataService {
    constructor(firebaseSync, jobDataService, db, postcodeManager, pricingService, clients, eTradeTypes) {
        this.firebaseSync = firebaseSync;
        this.jobDataService = jobDataService;
        this.db = db;
        this.postcodeManager = postcodeManager;
        this.pricingService = pricingService;
        this.clients = clients;
        this.eTradeTypes = eTradeTypes;
        /*
          Question types
          1: free text
          2: booking windows
          3: contact details
          4: confirmation
          5: quantity
          6: 2 options
          7: select tap model
          8: numeric
          9: yes/no
          10: simple 2 options
          11: handyman duration
          12: Job notes & photos
          13: carpentry duration
        */
        this.metaDataLoaded = false;
        this.metaDataLoading = false;
        this.currentPage = '';
        this.contactEmail = '';
        this.contactPhoneNumber = '';
        this.contactEmergencyNumber = '';
        this.contactPhoneHours = '';
        this.faqData = [];
        this.whereDidYouHearAboutUsData = [];
        this.priceEstimatePopupPlumbing = 'The price provided is an estimated cost based on the information you have submitted. If the works differ upon inspection by our Tradie this estimate will be altered accordingly.<br /><br />Furthermore, any alterations to existing pipework may result in additional costs.<br /><br />Your Tradie will discuss this in further detail with you when on-site.';
        this.priceEstimatePopupElectrical = 'The price provided is an estimated cost based on the information you have submitted. If the works differ upon inspection by our Tradie this estimate will be altered accordingly.<br /><br />Your Tradie will discuss this in further detail with you when on-site.';
        this.tradeTypes = [];
        this.homePagetradeTypes = [];
        this.tapsJobTypes = [];
        this.standardQuestions = [];
        this.currentTriageQuestion = null;
        this.postcodeCheck = false;
        this.homeInspectionID = 5;
        //
    }
    IsAAHomeInspection(tradeType) {
        if (tradeType == this.eTradeTypes.AAHealthyHomeInspection
            || tradeType == this.eTradeTypes.AABuildingInspection
            || tradeType == this.eTradeTypes.AARentalInspection
            || tradeType == this.eTradeTypes.AAMethamphetamineInspection
            || tradeType == this.eTradeTypes.AAAsbestosInspection) {
            return true;
        }
        return false;
    }
    loadMetaData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // if (this.metaDataLoaded || this.metaDataLoading) {
            //   return;
            // }
            // this.metaDataLoading = true;
            let service = this;
            let triageDataQuery = this.db.doc('/metadata/triage').ref;
            let siteDataQuery = this.db.doc('/metadata/site').ref;
            let postcodeDataQuery = this.db.doc('/metadata/postcode').ref;
            let bookingMetadataQuery = this.db.doc('/metadata/booking').ref;
            yield triageDataQuery.get().then(function (result) {
                let data = result.data();
                service.tradeTypes = JSON.parse(data.tradeTypes);
                service.tapsJobTypes = JSON.parse(data.tapsJobTypes);
                service.standardQuestions = JSON.parse(data.standardQuestions);
                service.homePagetradeTypes = [];
                service.tradeTypes.forEach(tradeType => {
                    if (!tradeType.hideOnHomePage) {
                        service.homePagetradeTypes.push(tradeType);
                    }
                });
            }).catch(function (error) {
                console.log('ERROR triageDataQuery: ' + error);
            });
            yield bookingMetadataQuery.get().then(function (result) {
                let data = result.data();
                service.bookingMetadata = data;
            }).catch(function (error) {
                console.log('ERROR bookingMetadataQuery: ' + error);
            });
            yield postcodeDataQuery.get().then(function (result) {
                let data = result.data();
                let postcodeData = data;
                service.postcodeManager.PostcodeGroups = [];
                for (let group of postcodeData.PostcodeGroups) {
                    group.PublicHolidays = [];
                    group.PricingAreas = [];
                    group.BlackoutPeriods = [];
                    group.PricingChanges = [];
                    // find all blackout periods that cover this postcode group
                    for (let blackoutPeriod of service.bookingMetadata.BlackoutPeriods) {
                        if (blackoutPeriod.PostcodeGroup == group.Name) {
                            group.BlackoutPeriods.push(blackoutPeriod);
                        }
                    }
                    // find all public holiday groups that cover this postcode group
                    for (let publicHolidayGroup of postcodeData.PublicHolidayGroups) {
                        let addPublicHolidays = false;
                        // convert strings to dates
                        let tempDates = publicHolidayGroup.Dates;
                        publicHolidayGroup.Dates = [];
                        for (let d of tempDates) {
                            publicHolidayGroup.Dates.push(new Date(d));
                        }
                        for (let postcodeGroup of publicHolidayGroup.PostcodeGroups) {
                            if (group.Name == postcodeGroup) {
                                addPublicHolidays = true;
                            }
                        }
                        if (addPublicHolidays) {
                            group.PublicHolidays.push(publicHolidayGroup);
                        }
                    }
                    // find all pricing areas that cover this postcode group
                    for (let pricingArea of postcodeData.PricingAreas) {
                        let addPricingArea = false;
                        for (let postcodeGroup of pricingArea.PostcodeGroups) {
                            if (group.Name == postcodeGroup) {
                                addPricingArea = true;
                            }
                        }
                        if (addPricingArea) {
                            group.PricingAreas.push(pricingArea);
                        }
                    }
                    // find all pricing changes that cover this postcode group
                    if (postcodeData.PricingChanges != null && postcodeData.PricingChanges.length > 0) {
                        for (let pricingChange of postcodeData.PricingChanges) {
                            let addPricingChange = false;
                            for (let postcodeGroup of pricingChange.PostcodeGroups) {
                                if (group.Name == postcodeGroup) {
                                    addPricingChange = true;
                                }
                            }
                            if (addPricingChange) {
                                group.PricingChanges.push(pricingChange);
                            }
                        }
                    }
                    let tempGroup = new PostcodeGroup();
                    Object.setPrototypeOf(group, Object.getPrototypeOf(tempGroup));
                    service.postcodeManager.PostcodeGroups.push(group);
                }
            }).catch(function (error) {
                console.log('ERROR postcodeDataQuery: ' + error);
            });
            yield siteDataQuery.get().then(function (result) {
                let data = result.data();
                service.contactEmail = data.email;
                service.contactPhoneHours = data.phoneHours;
                service.contactPhoneNumber = data.phoneNumber;
                service.contactEmergencyNumber = data.emergencyNumber;
                let wdyhau = data.whereDidYouHearAboutUs;
                let faq = data.faq;
                if (wdyhau != null && wdyhau.length > 0) {
                    service.whereDidYouHearAboutUsData = JSON.parse(wdyhau);
                }
                let cancelFee = 65;
                if (environment.clientID == service.clients.AANZ) {
                    cancelFee = 35;
                }
                if (faq != null && faq.length > 0) {
                    service.faqData = JSON.parse(faq);
                    // replace the key with the value in faq titles and descriptions
                    let faqReplace = {
                        "{{productName}}": environment.productName,
                        "{{contactEmail}}": service.contactEmail,
                        "{{contactPhoneNumber}}": service.contactPhoneNumber,
                        "{{contactPhoneHours}}": service.contactPhoneHours,
                        "{{cancelFee}}": cancelFee.toString(),
                    };
                    service.faqData.forEach(f => {
                        for (let key in faqReplace) {
                            let value = faqReplace[key];
                            f.title = f.title.split(key).join(value);
                            f.description = f.description.split(key).join(value);
                        }
                    });
                }
            }).catch(function (error) {
                console.log('ERROR siteDataQuery: ' + error);
            });
            this.metaDataLoaded = true;
            this.metaDataLoading = false;
        });
    }
    checkPostcode(postcode, tradeTypeID) {
        this.postcodeCheck = false;
        if (this.postcodeManager.SelectedPostcodeGroup != null) {
            this.postcodeCheck = this.postcodeManager.SelectedPostcodeGroup.IsPostcodeCovered(postcode);
        }
        if (this.postcodeCheck) {
            var tradeTypePricing = this.GetTradeTypePricing(tradeTypeID, postcode);
            if (tradeTypePricing == null) {
                this.postcodeCheck = false;
                return this.postcodeCheck;
            }
            if (tradeTypePricing != null) {
                if (tradeTypePricing.HourlyRate == 0) {
                    if (tradeTypePricing.CalloutFee == 0) {
                        // 20220620 - MM - if hourly rate and callout fee are both 0 for a given service, service not available in this postcode
                        // 20220620 - MM - to set to 0, use HomeServicesDataApp > Pricing Areas, find relevant postcode group, and edit relevant service 
                        this.postcodeCheck = false;
                    }
                }
            }
        }
        return this.postcodeCheck;
    }
    IsPostcodeCovered(postcode) {
        for (let postcodeGroup of this.postcodeManager.PostcodeGroups) {
            for (let p of postcodeGroup.Postcodes) {
                if (postcode == p) {
                    return true;
                }
            }
        }
        return false;
    }
    pushAADataLayerPageView(postcode) {
        if (environment.clientID != this.clients.AANZ) {
            return;
        }
        window.dataLayer.push({
            event: 'postcode_check',
            postcode: postcode,
        });
    }
    pushAACompletedBooking(jobref, trade, estimate) {
        if (environment.clientID != this.clients.AANZ) {
            return;
        }
        window.dataLayer.push({
            event: 'completed_booking',
            estimate: estimate,
            job_reference: jobref,
            trade: trade,
        });
    }
    pushAAStartTrade(trade) {
        if (environment.clientID != this.clients.AANZ) {
            return;
        }
        window.dataLayer.push({
            event: 'trade_selected',
            trade: trade,
        });
    }
    pushAAStartExternalTrade(trade) {
        if (environment.clientID != this.clients.AANZ) {
            return;
        }
        window.dataLayer.push({
            event: 'external_trade_selected',
            trade: trade,
        });
    }
    pushAAIsMemberSelected(isMember) {
        if (environment.clientID != this.clients.AANZ) {
            return;
        }
        window.dataLayer.push({
            event: 'is_aa_member',
            is_member: isMember,
        });
    }
    convertURLName(name) {
        var newName = name.split(' ').join('-');
        newName = newName.split('_').join('-');
        return newName.toLowerCase();
    }
    GetPostcodeGroups(postcode) {
        let groups = new Array();
        for (let group of this.postcodeManager.PostcodeGroups) {
            if (group.Postcodes.indexOf(postcode) > -1) {
                groups.push(group);
                continue;
            }
        }
        return groups;
    }
    IsTradeTypeBlackoutDate(tradeTypeID, postcode, date) {
        let postcodeGroups = this.GetPostcodeGroups(postcode);
        if (postcodeGroups == null || postcodeGroups.length == 0) {
            return false;
        }
        for (let postcodeGroup of postcodeGroups) {
            for (let blackoutPeriod of postcodeGroup.BlackoutPeriods) {
                if (blackoutPeriod.TradeTypeID == tradeTypeID
                    && date >= new Date(blackoutPeriod.StartDate)
                    && date <= new Date(blackoutPeriod.EndDate)) {
                    return true;
                }
            }
        }
        return false;
    }
    GetTradeTypePricing(tradeTypeID, postcode) {
        let postcodeGroups = this.GetPostcodeGroups(postcode);
        if (postcodeGroups == null || postcodeGroups.length == 0) {
            return null;
        }
        for (let group of postcodeGroups) {
            var pricing = group.GetTradeTypePricing(tradeTypeID);
            if (pricing != null) {
                return pricing;
            }
        }
        return null;
    }
    GetJobTypePricing(tradeTypeID, jobTypeID, postcode) {
        let postcodeGroups = this.GetPostcodeGroups(postcode);
        if (postcodeGroups == null || postcodeGroups.length == 0) {
            return null;
        }
        for (let group of postcodeGroups) {
            var pricing = group.GetJobTypePricing(tradeTypeID, jobTypeID);
            if (pricing != null) {
                return pricing;
            }
        }
        return null;
    }
    GetPricingChangeByJobTypeID(jobTypeID, postcode) {
        let postcodeGroups = this.GetPostcodeGroups(postcode);
        if (postcodeGroups == null || postcodeGroups.length == 0) {
            return null;
        }
        for (let group of postcodeGroups) {
            var pricing = group.GetPricingChangeByJobTypeID(jobTypeID);
            if (pricing != null) {
                return pricing;
            }
        }
        return null;
    }
    GetPricingChangeByTradeTypeID(tradeTypeID, postcode) {
        let postcodeGroups = this.GetPostcodeGroups(postcode);
        if (postcodeGroups == null || postcodeGroups.length == 0) {
            return null;
        }
        for (let group of postcodeGroups) {
            var pricing = group.GetPricingChangeByTradeTypeID(tradeTypeID);
            if (pricing != null) {
                return pricing;
            }
        }
        return null;
    }
}
MetaDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MetaDataService_Factory() { return new MetaDataService(i0.ɵɵinject(i1.FirebaseSyncService), i0.ɵɵinject(i2.JobDataService), i0.ɵɵinject(i3.AngularFirestore), i0.ɵɵinject(i4.PostcodeManagerService), i0.ɵɵinject(i5.PricingService), i0.ɵɵinject(i6.Clients), i0.ɵɵinject(i6.TradeTypes)); }, token: MetaDataService, providedIn: "root" });
export class BlackoutPeriod {
}
export class BookingMetadata {
    constructor() {
        this.BlackoutPeriods = [];
    }
}
export class PostcodeData {
    constructor() {
        this.PostcodeGroups = [];
        this.PublicHolidayGroups = [];
        this.PricingAreas = [];
        this.PricingChanges = [];
    }
}
export class PostcodeGroup {
    constructor() {
        this.Name = '';
        this.Postcodes = [];
        this.AllowNextDayBooking = false;
        this.OverrideBlackoutDays = null;
        this.PublicHolidays = [];
        this.PricingAreas = [];
        this.PricingChanges = [];
        this.BlackoutPeriods = [];
    }
    IsPostcodeCovered(postcode) {
        for (let p of this.Postcodes) {
            if (postcode == p) {
                return true;
            }
        }
        return false;
    }
    IsPublicHoliday(date) {
        let dateString = date.toDateString();
        for (let publicHolidayGroup of this.PublicHolidays) {
            for (let d of publicHolidayGroup.Dates) {
                if (dateString == d.toDateString()) {
                    return true;
                }
            }
        }
        return false;
    }
    GetTradeTypePricing(tradeTypeID) {
        for (let pricingArea of this.PricingAreas) {
            for (let tradeType of pricingArea.TradeTypes) {
                if (tradeType.TradeTypeID == tradeTypeID) {
                    return tradeType;
                }
            }
        }
        return null;
    }
    GetJobTypePricing(tradeTypeID, jobTypeID) {
        for (let pricingArea of this.PricingAreas) {
            for (let tradeType of pricingArea.TradeTypes) {
                if (tradeType.TradeTypeID == tradeTypeID) {
                    for (let jobType of tradeType.JobTypes) {
                        if (jobType.JobTypeID == jobTypeID) {
                            return jobType;
                        }
                    }
                }
            }
        }
        return null;
    }
    GetPricingChangeByTradeTypeID(tradeTypeID) {
        if (this.PricingChanges == null || this.PricingChanges.length == 0) {
            return null;
        }
        for (let pricingChange of this.PricingChanges) {
            for (let tradeType of pricingChange.TradeTypes) {
                if (tradeType == tradeTypeID) {
                    return pricingChange;
                }
            }
        }
        return null;
    }
    GetPricingChangeByJobTypeID(jobTypeID) {
        if (this.PricingChanges == null || this.PricingChanges.length == 0) {
            return null;
        }
        for (let pricingChange of this.PricingChanges) {
            for (let tradeType of pricingChange.JobTypes) {
                if (tradeType == jobTypeID) {
                    return pricingChange;
                }
            }
        }
        return null;
    }
} // PostcodeGroup
export class PublicHolidaysGroup {
    constructor() {
        this.Name = '';
        this.Dates = [];
        this.PostcodeGroups = [];
    }
}
export class JobTypePricing {
    constructor() {
        this.PartsCostBase = null;
        this.PartsCostPremium = null;
        this.AttendanceHours = null;
        this.HourlyRate = null;
        this.CalloutFee = null;
        this.OutOfHoursHourlyRate = null;
        this.OutOfHoursCalloutFee = null;
        this.AdditionalCalloutFee = null;
    }
}
export class TradeTypePricing {
    constructor() {
        this.JobTypes = [];
        this.HourlyRate = null;
        this.CalloutFee = null;
        this.OutOfHoursHourlyRate = null;
        this.OutOfHoursCalloutFee = null;
        this.AdditionalCalloutFee = null;
        this.OverrideBlackoutDays = null;
        this.OverrideMemberDiscountPercent = null;
    }
}
export class PricingArea {
    constructor() {
        this.Name = '';
        this.PostcodeGroups = [];
        this.TradeTypes = [];
    }
}
export class PricingChange {
    constructor() {
        this.Name = '';
        this.PostcodeGroups = [];
        this.TradeTypes = [];
        this.JobTypes = [];
    }
}
export class FAQItem {
    constructor(_title, _description) {
        this.title = '';
        this.description = '';
        this.show = false;
        this.title = _title;
        this.description = _description;
    }
}
export class Suburb {
    constructor() {
        this.postcode = 0;
        this.name = '';
    }
}
export class TradeType {
    constructor() {
        this.id = 0;
        this.urlID = '';
        this.name = '';
        this.icon = '';
        this.overrideBlackoutDays = -1;
        this.link = '';
        this.endPopup = '';
        this.hourlyRate = 0;
        this.calloutFee = 0;
        this.nextDayBooking = false;
        this.jobTypes = [];
        this.bookingType = 1; // 1 = scheduled, 2 = HIP, 3 = EHA
        this.hideOnHomePage = false;
        // out of hours
        this.oohHourlyRate = null;
        this.oohCalloutFee = null;
    }
}
export class JobType {
    constructor() {
        this.id = 0;
        this.name = '';
        this.icon = '';
        this.hideIcon = false;
        this.route = '';
        this.partsIconBase = '';
        this.partsIconPremium = '';
        this.partsCostBase = 0;
        this.partsCostPremium = 0;
        this.partsNameBase = 'Standard';
        this.partsNamePremium = 'Premium';
        this.partsInfoBase = '';
        this.partsInfoPremium = '';
        this.productCode = '';
        this.attendanceHours = 1;
        this.emergency = false;
        this.confirmPopupKey = '';
        this.redirectTrade = '';
        this.questions = [];
        this.inclusions = '';
        this.calloutFee = 0;
        this.additionalPartsFree = false;
        // out of hours
        this.oohCalloutFee = null;
        this.oohAttendanceHours = null;
        this.showGeneralNotes = true;
        this.showJobPhotos = true;
        // used by booking platform only
        this.jobTypeIndex = -1;
        this.currentBasePartsCost = 0;
        this.currentPremiumPartsCost = 0;
        this.estimatedCurrentPrice = 0;
        this.estimatedFullPrice = 0;
        this.estimatedDuration = 0;
        this.currentQuantity = 0;
        this.firstQuestionIndex = -1;
        this.standardModel = false;
        this.currentAttendanceHours = 0;
        this.currentHourlyMultiplier = 0;
    }
}
export class TriageQuestion {
    constructor() {
        this.id = 0;
        this.icon = '';
        this.description = '';
        this.jobTypeID = 0;
        this.questionTypeID = 0;
        this.listOrder = 0;
        this.nextPopup = '';
        this.nextPopupKey = '';
        this.options = [];
        this.data = '';
        this.progressStep = 1;
        this.required = true;
        this.outgoingField = true;
        this.additionalFixedCost = 0;
        this.additionalFixedCostAnswer = '';
        this.additionalFixedCostAnswerMatrix = [];
        this.additionalPerCost = 0;
        this.additionalPerCostAnswer = '';
        this.modifiedBasePartsCost = 0;
        this.modifiedBasePartsAnswer = '';
        this.modifiedPremiumPartsCost = 0;
        this.modifiedPremiumPartsAnswer = '';
        this.modifiedAttendanceHours = 0;
        this.modifiedAttendanceHoursAnswer = '';
        this.modifiedHourlyMultiplier = 0;
        this.modifiedHourlyMultiplierAnswer = '';
        this.quantity = false;
        this.startPricing = false;
        this.hourlyMultiplier = 0;
        this.partsMultiplier = 0;
        this.partsAdd = 0;
        this.defaultAnswer = '';
        this.showStandardButtons = true;
        this.showConfirmButtons = false;
    }
}
export class TriageQuestionOption {
    constructor() {
        this.id = 0;
        this.name = '';
        this.icon = '';
        this.data = [];
        this.fullAnswer = '';
    }
}
export class TriageQuestionData {
    constructor() {
        this.question = null;
        this.answer = '';
        this.fullAnswer = '';
        this.show = false;
        this.showPopup = false;
        this.popupShown = false;
        this.index = 0;
        this.valid = false;
        // used by booking platform only
        this.jobTypeIndex = -1;
    }
}
export class AdditionalFixedPriceMatrixItem {
    constructor() {
        this.answer = '';
        this.price = 0;
    }
}
